import type { FC, ReactNode } from 'react'

import type { WhiteLabel } from '@skytech/types'

import './styles.scss'

export const Label: FC<{
  htmlFor?: string
  className?: string
  capitalizeLabel?: boolean
  marginBottom?: number
  children: ReactNode
}> = ({ className = '', capitalizeLabel, children, marginBottom, ...restOfProps }) => {
  const capitalizeClass = capitalizeLabel ? 'capitalize' : ''

  // todo: replace with the org from url when ready
  const whiteLabel = localStorage.getItem('org') as WhiteLabel

  return (
    <label
      className={`ui-label ${className} ${whiteLabel} ${capitalizeClass}`}
      style={{ marginBottom: typeof marginBottom === 'number' ? marginBottom : '0.5rem' }}
      {...restOfProps}
    >
      {children}
    </label>
  )
}
